import React from 'react';
import { useNotificationsContext } from '../../../contexts/NotificationsContext';
import { NotificationToast } from './NotificationToast';

export const Notifications = () => {
  const { notifications } = useNotificationsContext();

  return (
    <>
      {notifications.map(({ id, message, title, type, timeout, size }) => {
        return (
          <NotificationToast
            key={id}
            id={id}
            message={message}
            title={title}
            type={type}
            timeout={timeout}
            size={size}
          />
        );
      })}
    </>
  );
};
